import React, { useState, useEffect } from "react";
import ForecastDate from "./ForecastDate";
import axios from "axios";
import { TailSpin } from "react-loader-spinner";

export default function Forecast(props) {
  //recived props from Search
  let [loaded, setLoaded] = useState(false); // variable for checking status
  let [forecast, setForecast] = useState(null);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  useEffect(() => {
    setLoaded(false); //restart APi call
  }, [props.coordinates]); //if coordinates changed

  //console.log(forecast[0].);
  if (loaded) {
    return (
      <div className="Forecast">
        <div className="row mt-4 mb-4">
          {forecast.map(function (day, index) {
            //mapping forecast for every day
            if (index < 5) {
              //if a day less than 5 (we want to show only 6 items)
              return <ForecastDate data={day} key={index} />; //show forecast, sending timestamp
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    let apiKey = "ae7a846b3048f734526a71e1a47e2b4b";
    //console.log();
    let lon = props.coordinates.lon;
    //for new API call we need lontitude and latitude, that we recive from Search
    let lat = props.coordinates.lat;

    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
    return <TailSpin height="50" width="50" radius="9" color="#2c5d63" />;
  }
}
